import React, { useState, useEffect } from 'react';

import { connect } from "react-redux";
import * as msgs from "../../../constants/textConstants";
import * as types from "../../../constants/actionTypes";
import * as Tools from "../../../helpers/Tools";
import { logUI } from "../../../api/andyliticsApi";
import { withRouter } from "react-router-dom";
import { Navigation } from '../../ecosystem';

const Nav = (props) => {
    const {
        siteMenuItems,
        toggleMainMenu,
        updateActiveNavTriggers,
        onLogoutClick,
        clearSearch,
        isDashboardMenuCollapsed,
        onNavLayoutChange,
        screenBreakPoint
    } = props;

    const isMobileMenu = (screenBreakPoint === msgs.XS_MOBILE || screenBreakPoint === msgs.SM_MOBILE || screenBreakPoint === msgs.MD_TABLET) ? true : false;

    return <>
        <Navigation
            className="menu-list-nav-container"
            menuItems={siteMenuItems}
            onNavHeadClick={(e, label) => {
                if (label && label.toLowerCase() === 'sign out') {
                    onLogoutClick();
                }
                const labelTxt = label ? label.replace(/\s+/g, '') : '';
                if (labelTxt) {
                    logUI(`MBHWeb.UI.Menu.${labelTxt}.Clicked`, new Date(), Tools.getURLPath());
                }
            }}
            onNavItemClick={(e, label) => {
                if (label && label.toLowerCase() === 'sign out') {
                    onLogoutClick();
                } else if (label && label.toLowerCase() === 'find care') {
                    clearSearch();
                }
                const labelTxt = label ? label.replace(/\s+/g, '') : '';
                if (labelTxt) {
                    logUI(`MBHWeb.UI.Menu.${labelTxt}.Clicked`, new Date(), Tools.getURLPath());
                }
            }}
            showArrow={false}
            toggleMainMenu={() => { toggleMainMenu(); }}
            updateActiveNavTriggers={updateActiveNavTriggers}
            collapsed={!isMobileMenu && isDashboardMenuCollapsed}
            showCollapsedButton={!isMobileMenu}
            toggleMenuCollapsed={() => { onNavLayoutChange(!isDashboardMenuCollapsed); }}
        />
    </>;
}
const mapStateToProps = (state) => {
    return {
        isDashboardMenuCollapsed: state.domain.dmc,
        screenBreakPoint: state.common.screenBreakPoint
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        onLogoutClick: () => dispatch({ type: types.LOGOUT, logoutMessage: msgs.UserInitiatedLogoutMessage }),
        clearSearch: () => {
            dispatch({ type: types.SEARCH_PROVIDER_CLEAR });
            dispatch({ type: types.SEARCH_LOCATION_CLEAR });
        },
        onNavLayoutChange: (isDashboardMenuCollapsed) => dispatch({ type: types.DASHBOARD_MENU_COLLAPSIBLE_STATE_CHANGE, isDashboardMenuCollapsed: isDashboardMenuCollapsed })
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Nav));
